import React from "react";

/**
 * Sigil for kin without a generated avatar image.
 * A breathing colored disc with the kin's first letter rendered as a serif sigil.
 */
export default function KinSigil({ name, hex = "#526357", size = 64 }) {
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={`sigil of ${name}`}
    >
      <defs>
        <radialGradient id={`sg-${name}`} cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor={hex} stopOpacity="0.95" />
          <stop offset="70%" stopColor={hex} stopOpacity="0.55" />
          <stop offset="100%" stopColor={hex} stopOpacity="0.85" />
        </radialGradient>
      </defs>
      <circle
        cx="32"
        cy="32"
        r="30"
        fill={`url(#sg-${name})`}
        stroke="#D8D3C4"
        strokeWidth="1"
      />
      <circle
        cx="32"
        cy="32"
        r="30"
        fill="none"
        stroke={hex}
        strokeOpacity="0.4"
        strokeWidth="0.5"
      />
      <text
        x="32"
        y="42"
        textAnchor="middle"
        fontFamily="Cormorant Garamond, serif"
        fontStyle="italic"
        fontSize="34"
        fill="#F4F1E8"
        opacity="0.95"
      >
        {initial}
      </text>
    </svg>
  );
}
